(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bw-new-arrivals-slider"] && !Shopify.designMode) return;
  try {
    
function setupArrivalsControls(root){
  root.querySelectorAll('.bw-new-arrivals').forEach(section=>{
    if(section.dataset.controlsReady)return;
    const grid=section.querySelector('.bw-new-arrivals__grid');
    const previous=section.querySelector('[data-arrivals-prev]');
    const next=section.querySelector('[data-arrivals-next]');
    if(!grid||!previous||!next)return;
    section.dataset.controlsReady='true';
    const update=()=>{previous.disabled=grid.scrollLeft<=1;next.disabled=grid.scrollLeft+grid.clientWidth>=grid.scrollWidth-2;};
    const move=direction=>{const card=grid.querySelector('.bw-new-arrivals__card');const distance=card.getBoundingClientRect().width+parseFloat(getComputedStyle(grid).columnGap||0);grid.scrollBy({left:direction*distance,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
    previous.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
    grid.addEventListener('scroll',update,{passive:true});
    new ResizeObserver(update).observe(grid);update();
  });
}
setupArrivalsControls(document);
document.addEventListener('shopify:section:load',()=>setupArrivalsControls(document));

  } catch(e) { console.error(e); }
})();
})();
